import { render } from "./SitePortfolio.vue?vue&type=template&id=58f9c745"
import script from "./SitePortfolio.vue?vue&type=script&lang=js"
export * from "./SitePortfolio.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rexvalkering-vuejs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__